module.exports = __webpack_public_path__ + "static/media/icon-community-eye.3c3fc9bc.svg";